module.exports = __webpack_public_path__ + "img/DTI-01.9e59f55c.png";